// ─────────────────────────────────────────────
//  SecondCrnaSection — the second CRNA / AA standing in this room.
//
//  ⚠️ RENDERED ONLY WHEN THERE ACTUALLY IS ONE. The product owner was explicit:
//  no empty second field on the 17 of 19 rooms that hold one person. Adding a
//  second provider is done from the quick-actions menu ("Assign Supervising
//  CRNA"), where the room and the person are both already in hand; this section
//  is what you get once somebody is there.
//
//  ⚠️ NO "STAGE RELIEF" HERE, DELIBERATELY. Staging writes
//  `crnaReliefId`/`mdReliefId`, which is what puts "Relief X — pending" and the
//  ✓ Take over button on the room card. There is no such pending slot for the
//  second provider, and inventing `orienteeReliefId` would put a field in
//  Firestore that NOTHING renders — a handover that looks agreed on this screen
//  and is invisible on the board and on the incoming provider's phone. Both
//  actions here are immediate, and both say so.
//
//  ⚠️ EVERY CONTROL NAMES THE PERSON. Two CRNAs are in this room and both can be
//  taken out of it; "Relieve CRNA" would be one verb for two actions, which is
//  the failure this repo already carries a scar for.
// ─────────────────────────────────────────────
import React from "react";
import Button from "../Button";
import st from "./caseModalStyles";

export default function SecondCrnaSection({
  roomName,
  seatName,
  secondName,
  pool = [],
  replId,
  setReplId,
  onReplace,
  onRemove,
  busy = false,
}) {
  if (!secondName) return null;
  return (
    <div style={st.section}>
      <div style={st.sectionTitle}>Second CRNA / AA</div>
      <div style={st.slot}>
        <div style={st.slotHead}>
          <span style={st.slotKind}>With {seatName || "the seat"}</span>
          <span style={st.slotName}>{secondName}</span>
        </div>
        <label style={st.field}>
          {`Replace ${secondName} with`}
          <select
            style={st.select}
            aria-label={`Replace ${secondName} with`}
            value={replId}
            onChange={(e) => setReplId(e.target.value)}
          >
            <option value="">— keep {secondName} —</option>
            {pool.map((p) => (
              <option key={p.id} value={p.id}>{(p.shortCode ? `${p.shortCode} — ` : "") + p.name}</option>
            ))}
          </select>
        </label>
      </div>
      <div style={st.applyRow}>
        <Button variant="secondary" onClick={onRemove} disabled={busy}>
          {`Remove ${secondName} from ${roomName}`}
        </Button>
        <Button onClick={onReplace} disabled={busy || !replId}>
          {`Replace ${secondName} now`}
        </Button>
      </div>
      <p style={st.stageNote}>
        {seatName
          ? `${seatName} keeps ${roomName} either way — these controls only move ${secondName}.`
          : `These controls only move ${secondName}.`}
      </p>
    </div>
  );
}
